import React from 'react';
import Detail from '../component/tracking/detailHalte';
import Header from '../component/template/Header';
import Footer from '../component/template/Footer';

function DetailHalte() {
  return (
    <div>
      <Header />
      <div className="content">
        <div className="tinggi-content">
          <Detail />
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default DetailHalte;